// import denormalizer from './denormalizer'
// import normalizer from './normalizer'
import Service, { getCallApiFunction } from '../service'
import { isUndefined } from 'lodash-es'

interface IParams {
  ssrLocale?: any
  params: any
}

class FetchCategoryMenuApi extends Service {
  constructor({ ssrLocale, params }: IParams) {
    super()
    this.name = 'FETCH_CATEGORY_MENU'

    const basicConfig = {
      url: `/v1/product/category/list`,
      method: 'GET',
      params: { ...params },
    }
    const localeConfig = {
      'Tutor-Header-Locale': ssrLocale,
    }
    const config = isUndefined(ssrLocale) ? basicConfig : { ...basicConfig, headers: localeConfig }

    this.config = config
  }
}

export const fetchCategoryMenu = (params: any) => getCallApiFunction(new FetchCategoryMenuApi(params))
